import { useGetAccountReceivableReports } from 'api-hooks/report';
import useDefaultValuesReportDate from 'hooks/use-default-values-report-date';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function AccountReceivableReport() {
  const { t } = useTranslation();
  const defaultFilters = useDefaultValuesReportDate('transaction');

  return (
    <PivotReportTemplate
      title={t('common:account_receivable_report')}
      usePivotQuery={useGetAccountReceivableReports}
      completeName={['customer']}
      defaultFilters={defaultFilters}
    />
  );
}
